/**
 * ceci est le modal de creation tache
 *
 * la valeur de resultat entendu doit etre dans le champ et active certains élément
 * mais pour "réponse" il n'y a rien mais seulement à envoyer
 */
import React, { useState, useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useMultipleFileUpload, useNotification } from "@hooks/index";
import { useReduxSelector } from "@hooks/useReduxSelector";
import { isEqual } from "lodash";
import { useForm, Controller, useWatch, FormProvider } from "react-hook-form";

import ModalIndex from "@Modals/layout/index";
//import CancelIcon from "@image/Close.svg";
//import DefaultDatePicker from "@components/arhDatePicker/DefaultDatePicker";
import FormSimple from "@components/formGroup/formSimple";
import FormTextarea from "@components/formGroup/formTextarea";
import InputFileMultipleArh from "@components/input/InputFileMultiple";
import ListboxEmploye from "@components/tailwindComponents/ListboxEmploye";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";

import { TASK_EXPECTED_RESULT_LIST } from "../onboarding.config";
import { REGEX_VALID_FILES } from "@helpers/_constants";
// import {
//   formatDateToDateString,
//   formatDateStringToDate
// } from "@helpers/_functions";
import { convertToFormData } from "@helpers/_functions";
import { OnboardingTask } from "@services/all.services";

import DateManagement from "./DateManagement";

const WITH_UPLOAD_TASK_TYPES = [
  "document_sending",
  "signature_request",
  "electronic_signature"
];

const LANGUAGE_LIST = [
  { _id: "fr", name: "Francais" },
  { _id: "en", name: "Anglais" }
];

const PDF_FILE_TYPE = ".pdf,.PDF";

const ModalAddTask = (props) => {
  const { t } = useTranslation("beginEnd.protocol");
  const { showError, showSuccess } = useNotification();
  const {
    oldFiles,
    handleDeleteOldFiles,
    removeOldFiles,
    allFileDone,
    resetData,
    handleUploadStatusChange,
    resetInputFiles
  } = useMultipleFileUpload({ defaultFiles: props.task?.files });

  const methods = useForm();
  const { handleSubmit, control, reset, setValue, formState } = methods;

  const expectedResultType = useWatch({
    name: "expectedResultType",
    defaultValue: null,
    control
  });

  const [isSaving, setIsSaving] = useState(false);
  const taskExpectedTranslated = useMemo(
    () =>
      TASK_EXPECTED_RESULT_LIST.map((option) => ({
        name: t(option.name),
        _id: option._id
      }))?.filter((type) => type._id !== "request_job"),
    [t]
  );

  const rawEmployeeList = useReduxSelector(
    (state) => state.evaluation.eligibleEvaluator.list
  );

  useEffect(() => {
    if (props.show) {
      resetData();
      let initialFormData = {};

      if (props.task) {
        const expectedResultType = TASK_EXPECTED_RESULT_LIST.find(
          (t) => t._id === props.task.expectedResultType
        );

        const predictedDateTriggerTask = props.taskList.find(
          (t) => t._id === props.task.predictedDateTriggerTask
        );

        initialFormData = {
          ...props.task,
          expectedResultType,
          assignedTo: populateAssignedTo(
            props.task.assignedTo,
            rawEmployeeList
          ),
          documentLanguage:
            props.task.documentLanguage &&
            LANGUAGE_LIST.find((e) => e._id === props.task.documentLanguage),

          includeDate: !!predictedDateTriggerTask,
          predictedDateTriggerTask,
          deadlineDateTriggerTask: props.taskList.find(
            (t) => t._id === props.task.deadlineDateTriggerTask
          ),
          predictedDateTriggerInterval:
            props.task.predictedDateTriggerInterval?.toString() || "1",
          deadlineDateTriggerInterval:
            props.task.deadlineDateTriggerInterval?.toString() || "1"
        };
      } else {
        initialFormData = {
          name: "",
          detail: "",
          expectedResultType: "",
          newFiles: [],
          assignedTo: [],
          includeDate: false,
          predictedDateTriggerTask: null,
          deadlineDateTriggerTask: null,
          predictedDateTriggerInterval: "1",
          deadlineDateTriggerInterval: "1"
        };
      }

      reset(initialFormData);
      resetInputFiles();
      setIsSaving(false);
    }
  }, [props.show]);

  useEffect(() => {
    resetInputFiles();
    setValue("newFiles", [], { shouldValidate: formState.isSubmitted });
  }, [expectedResultType]);

  async function handleSubmitSuccess(formValue) {
    setIsSaving(true);
    try {
      let {
        files,
        newFiles,
        expectedResultType,
        predictedDateTriggerInterval,
        predictedDateTriggerTask,
        deadlineDateTriggerInterval,
        deadlineDateTriggerTask,
        ...requestData
      } = formValue;

      let dateValue = {};
      if (formValue.includeDate) {
        dateValue = {
          predictedDateTriggerInterval: +predictedDateTriggerInterval || 0,
          predictedDateTriggerTask: predictedDateTriggerTask?._id,
          deadlineDateTriggerInterval: +deadlineDateTriggerInterval || 0,
          deadlineDateTriggerTask: deadlineDateTriggerTask?._id
        };
      } else {
        dateValue = {
          predictedDateTriggerInterval: 0,
          predictedDateTriggerTask: null,
          deadlineDateTriggerInterval: 0,
          deadlineDateTriggerTask: null
        };
      }

      requestData = {
        ...requestData,
        ...dateValue,
        files: newFiles,
        expectedResultType: expectedResultType._id,
        assignedTo: getAssignedTo(formValue.assignedTo),
        sourceModel: "OnboardingTask",
        documentLanguage: requestData?.documentLanguage?._id
      };

      if (props.task) {
        // update
        await removeOldFiles();

        const taskId = props.task._id;
        const taskUpdated = await OnboardingTask.updateTask(
          taskId,
          convertToFormData(requestData)
        );
        if (isEqual(taskUpdated, "FORBIDDEN")) {
          showError("already_exists", { object: "taskUpper" });
          setIsSaving(false);
          return;
        }
        showSuccess("update_action_success", { object: "task" });
      } else {
        // create
        const formData = convertToFormData({
          ...requestData,
          protocol: props.protocolId,
          Enterprise: localStorage.getItem("enterpriseId")
        });
        const taskCreated = await OnboardingTask.createTask(formData);
        if (isEqual(taskCreated, "FORBIDDEN")) {
          setIsSaving(false);
          showError("already_exists", { object: "taskUpper" });
          return;
        }
        showSuccess("creation_action_success", { object: "task" });
      }

      props.onClickClose();
    } catch (err) {
      console.error(err);
      showError("error");
      setIsSaving(false);
    }
  }

  function getAssignedTo(rawAssignedTo) {
    const formattedAssignedTo = rawAssignedTo.map(({ id }) => id);

    if (!props.task) {
      return formattedAssignedTo;
    }

    const savedAssignedTo = props.task.assignedTo;

    const savedNotInList = savedAssignedTo.filter(
      (saved) => !rawEmployeeList.some((employer) => employer.id === saved)
    );
    return [...formattedAssignedTo, ...savedNotInList];
  }

  function handleSubmitError(error) {
    // console.log({ error });
    showError("field_obligatory");
  }

  return (
    <ModalIndex
      isOpen={props.show}
      onClickClose={props.onClickClose}
      title={
        props.task ? t("Modification d’une tache") : t("Création d’une tache")
      }
      buttonOptions={{
        click: handleSubmit(handleSubmitSuccess, handleSubmitError),
        color: "green",
        title: props.task ? t("Modifier") : t("Créer")
      }}
      buttonCancelOptions={{
        click: props.onClickClose,
        color: "outlined",
        title: t("Annuler")
      }}
      mustWaiting={!allFileDone}
      isLoading={isSaving}
    >
      <div className="arh-relative">
        <Controller
          control={control}
          name="name"
          defaultValue=""
          rules={{ required: true }}
          render={({
            field: { onChange, onBlur, value },
            fieldState: { invalid }
          }) => (
            <FormSimple
              label={t("Tâche à réaliser")}
              placeholder={t("Nom du tâche")}
              ParentForm="arh-mb-[0.938rem]"
              classLabel="arh-flex"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              invalid={invalid}
            />
          )}
        />

        <Controller
          control={control}
          name="detail"
          defaultValue=""
          render={({ field: { onChange, onBlur, value } }) => (
            <FormTextarea
              label={t("Détails/consignes")}
              placeholder={t("Détails/consignes")}
              ParentForm="arh-mb-[0.938rem]"
              classTextarea="arh-resize-none arh-h-[5.625rem] arh-max-h-[5.625rem]"
              classLabel="arh-flex"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
            />
          )}
        />
        <Controller
          control={control}
          name="expectedResultType"
          defaultValue=""
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { invalid } }) => (
            <div className="arh-mb-[0.938rem] arh-w-full">
              <label
                className={`arh-mb-1 arh-flex arh-w-full  arh-font-poppins arh-text-xs arh-font-medium ${
                  invalid ? "arh-text-[#F60A20]" : "arh-text-black"
                }`}
              >
                {t("Résultat attendu")}
              </label>
              <div className="dropdown_content_hour dropdown_hoursWorking filter_posteAvailable arh-w-full">
                <ListboxSimple
                  placeholder={t("Résultat attendu")}
                  name={"expectedResultType"}
                  optionList={taskExpectedTranslated}
                  selectedValue={value}
                  setSelectedValue={onChange}
                  invalid={invalid}
                />
              </div>
            </div>
          )}
        />

        {WITH_UPLOAD_TASK_TYPES.includes(expectedResultType?._id) && (
          <Controller
            control={control}
            name="newFiles"
            defaultValue={[]}
            rules={{
              validate: {
                required: (newFiles) => {
                  if (
                    expectedResultType?._id === "signature_request" ||
                    expectedResultType?._id === "electronic_signature"
                  ) {
                    return true;
                  }
                  return newFiles.length !== 0 || oldFiles.length !== 0;
                }
              }
            }}
            render={({
              field: { onChange, value },
              fieldState: { invalid }
            }) => (
              <div className="arh-mb-[0.938rem] arh-w-full">
                <label
                  className={`arh-mb-1 arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${
                    invalid ? "arh-text-[#F60A20]" : "arh-text-black"
                  }`}
                >
                  {t("Ajouter le document")}
                </label>
                <div className="input_file_theme_employer">
                  <InputFileMultipleArh
                    handleChangeStatus={handleUploadStatusChange(
                      value,
                      onChange
                    )}
                    classUploadFile="arh-upload-createTask employer_theme_upload GreenThemeSelect"
                    regexp={REGEX_VALID_FILES}
                    dataFile={oldFiles} // already uploaded files
                    onDeleteOldFile={handleDeleteOldFiles}
                    isValid={invalid}
                    accept={
                      expectedResultType?._id === "electronic_signature" &&
                      PDF_FILE_TYPE
                    }
                    maxFiles={
                      expectedResultType?._id === "electronic_signature" && 1
                    }
                  />
                </div>
              </div>
            )}
          />
        )}

        {expectedResultType?._id === "electronic_signature" && (
          <Controller
            control={control}
            name="documentLanguage"
            defaultValue={null}
            render={({
              field: { onChange, value },
              fieldState: { invalid }
            }) => (
              <div className="arh-w-full">
                <label
                  className={`arh-mb-1 arh-w-full arh-text-left arh-font-poppins arh-text-xs arh-font-medium ${
                    invalid ? "arh-text-[#F60A20]" : "arh-text-black"
                  }`}
                >
                  {t("Langue du document")}
                </label>
                <div className="dropdown_content_hour dropdown_hoursWorking filter_posteAvailable arh-w-full">
                  <ListboxSimple
                    placeholder={t("Langue du document")}
                    name="folderLocation"
                    optionList={LANGUAGE_LIST}
                    selectedValue={value}
                    setSelectedValue={onChange}
                    invalid={invalid}
                    customListHeight="arh-bottom-9"
                    customTranslator={t}
                  />
                </div>
              </div>
            )}
          />
        )}

        <Controller
          control={control}
          name="assignedTo"
          defaultValue={[]}
          render={({ field: { onChange, value, name } }) => (
            <div className="arh-mb-[0.938rem] arh-w-full">
              <ListboxEmploye
                label={t("Pré-attribuer à un employé")}
                placeholder={t("Assigné à")}
                name={name}
                optionList={rawEmployeeList}
                selectedValue={value}
                setSelectedValue={onChange}
                multiple
              />
            </div>
          )}
        />

        <FormProvider {...methods}>
          <DateManagement
            taskList={props.taskList}
            selectedTask={props.task}
          />
        </FormProvider>
      </div>
    </ModalIndex>
  );
};

/**
 * Maps the assignedTo array to an array of employee objects from the employerList.
 *
 * @param {Array} assignedTo - The array of assignee IDs.
 * @param {Array} employerList - The array of employee objects.
 * @return {Array} The array of employee objects assigned to the task.
 */
function populateAssignedTo(assignedTo, employerList) {
  return assignedTo
    .map((assignee) =>
      employerList.find((employee) => employee.id === assignee)
    )
    .filter((employee) => employee);
}

export default ModalAddTask;
